import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import srLogin from "../locales/sr/login.json";
import enLogin from "../locales/en/login.json";
import srPresence from "../locales/sr/presence.json";
import enPresence from "../locales/en/presence.json";
import srStats from "../locales/sr/stats.json";
import enStats from "../locales/en/stats.json";
import srKarnet from "../locales/sr/karnet.json";
import enKarnet from "../locales/en/karnet.json";
import srCalendar from "../locales/sr/calendar.json";
import enCalendar from "../locales/en/calendar.json";
import srDevices from "../locales/sr/devices.json";
import enDevices from "../locales/en/devices.json";
import srSettings from "../locales/sr/settings.json";
import enSettings from "../locales/en/settings.json";
import srProfile from "../locales/sr/profile.json";
import enProfile from "../locales/en/profile.json";
import srSidebar from "../locales/sr/sidebar.json";
import enSidebar from "../locales/en/sidebar.json";
import srNotifications from "../locales/sr/notifications.json";
import enNotifications from "../locales/en/notifications.json";

const savedLanguage = localStorage.getItem("appLanguage");
const initialLanguage = savedLanguage === "en" || savedLanguage === "sr" ? savedLanguage : "sr";

i18n.use(initReactI18next).init({
    resources: {
        sr: {
            login: srLogin,
            presence: srPresence,
            stats: srStats,
            karnet: srKarnet,
            calendar: srCalendar,
            devices: srDevices,
            settings: srSettings,
            profile: srProfile,
            sidebar: srSidebar,
            notifications: srNotifications,
        },
        en: {
            login: enLogin,
            presence: enPresence,
            stats: enStats,
            karnet: enKarnet,
            calendar: enCalendar,
            devices: enDevices,
            settings: enSettings,
            profile: enProfile,
            sidebar: enSidebar,
            notifications: enNotifications,
        },
    },
    lng: initialLanguage,
    fallbackLng: "sr",
    defaultNS: "login",
    interpolation: {
        escapeValue: false,
    },
});

if (typeof document !== "undefined") {
    document.documentElement.lang = initialLanguage;
}

export default i18n;
